var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{domProps:{"innerHTML":_vm._s(require('!html-loader!./../../../../../public/images/icons/svg/icons-compare.svg'))}},[_vm._v("Icon")])
}
var staticRenderFns = []

export { render, staticRenderFns }